export default __webpack_public_path__ + "static/media/emptycarts.8cfd3e7d.png";